module.exports = __webpack_public_path__ + "static/logobg-18eb4c6bb37219a07bb88cfacd480e22.svg";